type PerksGridProps = {
  children: React.ReactNode;
};

const PerksGrid: React.FC<PerksGridProps> = ({children}) => (
  <div className="grid gap-4 [grid-template-columns:repeat(auto-fill,minmax(var(--perk-card-min-width-desktop),1fr))]">
    {children}
  </div>
);

export default PerksGrid;
